import React, { useState }  from 'react';
import './Upperbox.css'
import { Link } from 'react-router-dom';

const Upperbox = () => {
  const [email, setEmail] = useState('  info@easytaxexperts.com');

  const handleEmailClick = () => {
    window.location.href = `mailto:${email}`;
  };
  return (
    <div className='upperbox'>
    <div className='contact-info'>
      <p>Call Us +1 (302)-200-2836</p>
      <b>|</b>
      <p onClick={handleEmailClick}>{email}</p>
    </div>
    <div className='link-container'>
      
      
      <Link to='/Signup' className="text-decoration-none">
        <p>Register</p>
      </Link>
      <b>|</b>
      <Link to='/login' className="text-decoration-none">
        <p>Login</p>
      </Link>
    </div>
  </div>
);
}

export default Upperbox;